module.exports = __webpack_public_path__ + "img/Layer.086a351e.png";